import { ProductFilterInput } from '@app-domains/meilisearch/types/product-search.types'

export function productTypeFilter(): ProductFilterInput {
    return { attribute: 'type', operator: 'EQ', values: ['product'] }
}

export function categoryFilter(name: string): ProductFilterInput {
    return { attribute: 'categories', operator: 'EQ', values: [name] }
}

export function brandFilter(name: string): ProductFilterInput {
    return { attribute: 'brand', operator: 'EQ', values: [name] }
}

export function themeFilter(name: string): ProductFilterInput {
    return { attribute: 'themes', operator: 'EQ', values: [name] }
}

export function rangeFilter(...names: string[]): ProductFilterInput {
    const values = [...new Set(names)]

    return { attribute: 'range', operator: values.length > 1 ? 'IN' : 'EQ', values }
}

export function saleFilter(): ProductFilterInput {
    return { attribute: 'isSale', operator: 'EQ', values: ['true'] }
}

export function newProductsFilter(): ProductFilterInput {
    return { attribute: 'isNew', operator: 'EQ', values: ['true'] }
}
